import { motion } from 'framer-motion'
import { useEffect } from 'react'
import './LoadingScreen.css'
import cloud from '../../assets/images/cloud.svg'
import logo from '../../assets/images/logoLoad.svg'
interface LoadingScreenProps {
  isLoading: boolean
  onComplete?: () => void
}

const LoadingScreen = ({ isLoading, onComplete }: LoadingScreenProps) => {
  // Управление скроллом
  useEffect(() => {
    if (isLoading) {
      // Скрываем скролл
      document.body.style.overflow = 'hidden'
      document.documentElement.style.overflow = 'hidden'
    } else {
      // Восстанавливаем скролл
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }

    // Cleanup при размонтировании компонента
    return () => {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }
  }, [isLoading])

  if (!isLoading) return null

  const handleButtonClick = () => {
    if (onComplete) {
      onComplete()
    }
  }

  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      {/* Декоративные элементы */}
      <div className="decorative-flower flower-1">
        <img src={cloud} alt="cloud" className="cloud-icon" />
      </div>

      <div className="decorative-flower flower-2">
        <img src={cloud} alt="cloud" className="cloud-icon" />
      </div>

      <div className="decorative-flower flower-3">
        <img src={cloud} alt="cloud" className="cloud-icon" />
      </div>

      <div className="decorative-flower flower-4">
        <img src={cloud} alt="cloud" className="cloud-icon" />
      </div>

      {/* Основной контент */}
      <div className="loading-content">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          <img src={logo} alt="logo" className="logo" />
        </motion.div>
        <motion.div
          className="loading-progress-container"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
        >
          <motion.div
            className="loading-progress"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8, duration: 0.5 }}
          >
            <motion.div
              className="loading-progress-fill"
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{
                delay: 1.2,
                duration: 3,
                ease: [0.25, 0.1, 0.25, 1], // Кубическая кривая для более реалистичного заполнения
              }}
            />
          </motion.div>
          <motion.p className="loading-button">Loading...</motion.p>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default LoadingScreen
